import { SelectOption } from '../../types';

interface Props {
  className?: string;
  options: SelectOption[];
  value: string;
  onChange: (value: string) => void;
}
export default function TabBar({ className, options, value, onChange }: Props) {
  return (
    <div className={`tab-bar-block ${className}`}>
      {options.map((i) => (
        <div
          key={i.value}
          className={`tab-bar-item border-radius-24 ${i.value === value ? 'active' : ''}`}
          onClick={() => onChange(i.value.toString())}
        >
          <div className="label">{i.label}</div>
        </div>
      ))}
    </div>
  );
}
